import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// One site serves two audiences - staff under /dashboard and vendors under
// /vendor - so the browser tab has to follow the route instead of sitting as
// a single fixed line in index.html.
const DocumentTitle = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    document.title = pathname.startsWith('/vendor') ? 'DM Vendor' : 'DM Admin';
  }, [pathname]);

  return null;
};

export default DocumentTitle;
